import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { GiaHan } from "./GiaHan";
import { LichSuGiaHan } from "./LichSuGiaHan";
import { ChiTietDongLai } from "./ChiTietDongLai";
import NhanVayApi from "service/nhanVayApi";
import { pushNotification } from "utils/notifications";
import { useSelector, useDispatch } from "react-redux";
import { getListNhanVay, updateDataSearch } from "../../../../actions/NhanVay/";
import { convertToNumber } from "utils/numberExtension";
import { formatNumber } from "utils/currencyFormat";

export const ModalGiaHan = (props) => {
  const dispatch = useDispatch();
  const initDataGiaHan = {
    NhanVayId: props.NhanVayId,
    MaNhanVay: props.MaNhanVay,
    SoLanGiaHan: 0,
    LyDoGiaHan: "",
  };
  const [dataGiaHan, setDataGiaHan] = useState(initDataGiaHan);
  const updateTextValue = (field) => (e) => {
    setDataGiaHan({
      ...dataGiaHan,
      [field]: e.target.value,
    });
    if (e.target.value === 0 || e.target.value === "") {
      setErrors({
        ...errors,
        tienThanhLy: "Nhập số lần gia hạn thêm",
      });
      SoLanGiaHan.current.focus();
    } else {
      setErrors({
        ...errors,
        tienThanhLy: "",
      });
    }
  };
  const updateTextValue1 = (field) => (e) => {
    setDataGiaHan({
      ...dataGiaHan,
      [field]: e.target.value,
    });
    if (e.target.value.length === "") {
      setErrors1({
        ...errors1,
        tienThanhLy: "Nhập lý do gia hạn",
      });
      LyDoGiaHan.current.focus();
    } else {
      setErrors1({
        ...errors1,
        tienThanhLy: "",
      });
    }
  };
  const onChangeNumber = (field, value) => {
    setDataGiaHan({
      ...dataGiaHan,
      [field]: convertToNumber(value),
    });
  };

  //Thông báo
  const [alertShow, setShowHideAlert] = useState(false);
  const showAlert = () => setShowHideAlert(true);
  const hideAlert = () => setShowHideAlert(false);
  const [visible, setVisible] = useState(false);
  const onToggleSnackBar = () => setVisible(!visible);
  const onDismissSnackBar = () => setVisible(false);
  const thongbaoerror = "";
  const [thongbaoError, setThongBaoError] = useState(thongbaoerror);
  const dataSearch = useSelector((state) => state.dataSearchNhanVay);

  // const [refreshing, setRefreshing] = React.useState(false);
  // const onRefresh = React.useCallback(() => {
  //   setRefreshing(true);
  //   wait(100).then(() => setRefreshing(false));
  // }, []);

  const initErrors = {
    tienThanhLy: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const initErrors1 = {
    tienThanhLy: "",
  };
  const [errors1, setErrors1] = useState(initErrors1);
  const SoLanGiaHan = React.createRef();
  const LyDoGiaHan = React.createRef();
  const onSubmit = () => {
    // Validate
    if (
      dataGiaHan.SoLanGiaHan === 0 ||
      dataGiaHan.SoLanGiaHan === "" ||
      dataGiaHan.SoLanGiaHan === "0"
    ) {
      setErrors({
        ...errors,
        tienThanhLy: "Nhập số lần gia hạn thêm",
      });
      SoLanGiaHan.current.focus();
      return;
    } else if (dataGiaHan.LyDoGiaHan === "") {
      setErrors1({
        ...errors1,
        tienThanhLy: "Nhập lý do gia hạn",
      });
      LyDoGiaHan.current.focus();

      return;
    } else {
      //  setRefreshing(true);
      NhanVayApi.giaHanHopDongNhanVay(
        dataGiaHan.NhanVayId,
        dataGiaHan.MaNhanVay,
        dataGiaHan.SoLanGiaHan,
        dataGiaHan.LyDoGiaHan
      ).then((response) => {
        if (response.data.Error === 1) {
          pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
          return;
        } else {
          // showAlert();
          pushNotification(
            "Gia hạn kỳ thanh toán thành công",
            "success",
            "TOP_CENTER",
            1000
          );
          props.onHide();
          dispatch(getListNhanVay(dataSearch));
        }
      });
    }
  };
  return (
    <Modal
      {...props}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-notebook-check"></i>
          </span>
          Gia hạn hợp đồng
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <div className="row">
          <div className="col-md-12 col-lg-4 pad-right0">
            <div className="tattoan-formleft">
              <ul className="nav nav-tabs bg-tab" style={{ height: 50 }}>
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    id="base-tab1"
                    data-toggle="tab"
                    aria-controls="tab1"
                    href="#tab-thongtintt"
                    aria-expanded="true" 
                    style={{ height: 35 }}
                  >
                    <h4>Gia hạn</h4>
                  </a>
                </li>
              </ul>
              <div className="tab-content px-1 pt-1 pb-1 bg-content-tab">
                <div className="tab-pane active">
                  <div className="detail-tattoan">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label for="projectinput1">Mã nhận vay</label>
                          <span className="home-new-blue giahan-block">
                            {dataGiaHan.MaNhanVay}
                          </span>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label for="projectinput1">Số lần gia hạn thêm</label>
                          <input
                            type="text"
                            className="form-control input-sm"
                            value={dataGiaHan.SoLanGiaHan}
                            onChange={updateTextValue("SoLanGiaHan")}
                            name="SoLanGiaHan"
                            ref={SoLanGiaHan}
                          />
                        </div>
                        {errors.tienThanhLy && (
                          <span className="canh-bao-red">
                            {errors.tienThanhLy}
                          </span>
                        )}
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <label for="projectinput8">Lý do gia hạn</label>
                          <textarea
                            id="projectinput8"
                            rows="3"
                            className="form-control input-sm"
                            name="comment"
                            value={dataGiaHan.LyDoGiaHan}
                            onChange={updateTextValue1("LyDoGiaHan")}
                            ref={LyDoGiaHan}
                          ></textarea>
                        </div>
                        {errors1.tienThanhLy && (
                          <span className="canh-bao-red">
                            {errors1.tienThanhLy}
                          </span>
                        )}
                      </div>

                      <div className="col-md-12">
                        <div className="text-right">
                          <button
                            type="button"
                            className="btn btn-new-main btn-checknew"
                            onClick={onSubmit}
                          >
                            <span className="btn-icon-left">
                              <i className="mdi mdi-table-plus"></i>
                            </span>{" "}
                            Gia hạn
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="detail-giahan">
                    <h4>Lịch sử gia hạn</h4>
                    <LichSuGiaHan nhanvayId={props.NhanVayId} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-8">
            <div className="tattoan-formright">
              <ul className="nav nav-tabs bg-tab" style={{ height: 50 }}>
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    id="base-tab1"
                    data-toggle="tab"
                    aria-controls="tab1"
                    href="#tab-detailtt"
                    aria-expanded="true" 
                    style={{ height: 35 }}
                  >
                    <h4>Chi tiết đóng lãi</h4>
                  </a>
                </li>
              </ul>
              <div className="tab-content px-1 pt-1 pb-1 bg-content-tab">
                <div className="tab-pane active">
                  <ChiTietDongLai nhanvayId={props.NhanVayId} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
